import { useContext } from 'react';

// eslint-disable-next-line import/no-cycle -- TODO: pre-existing cycle via DataModelContext, fix when context is restructured
import { ContextMenuActionsContext } from 'contexts/context-menu-actions/ContextMenuActionsContext';

export const useContextMenuActions = () => {
  const contextMenuActionsState = useContext(ContextMenuActionsContext);
  return contextMenuActionsState;
};
